import React from 'react';
import { FormSpy } from 'react-final-form';
import { useDebouncedCallback } from 'use-debounce';

export default function AutoSave({ onChange, subscription = { values: true }, ...props }: any) {
    const [handleChange] = useDebouncedCallback(onChange, 250);

    return <FormSpy {...props} subscription={subscription} onChange={handleChange} />;
}
